import { collection, query, where, type Query } from 'firebase/firestore';
import { db } from './firebase';

/**
 * Architect Discussion list query. Constrains projectId so rules can prove
 * timberProjects.architectUids (the grant that already lets architects open the hub).
 * dealId is only used to build groupCommentKey.
 */
export function architectDesignTaskCommentsQuery(
  projectId: string,
  dealId: string,
): Query {
  const pid = projectId.trim();
  const did = dealId.trim();
  return query(
    collection(db, 'taskComments'),
    where('projectId', '==', pid),
    where('groupCommentKey', '==', `${did}::design`),
    where('audience', '==', 'architect'),
  );
}
